import { createRoot } from 'react-dom/client';

// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// project imports
import * as serviceWorker from 'serviceWorker';
import App from 'App';
import { store } from 'store';
import { set_logged_in, set_auth_token } from 'store/actions';
import keycloak from 'keycloak';

// style + assets
import 'assets/scss/style.scss';
import config from './config';

// ==============================|| REACT DOM RENDER  ||============================== //

const container = document.getElementById('root');
const root = createRoot(container);

const publishSession = () => {
  store.dispatch(set_logged_in(Boolean(keycloak.authenticated)));
  store.dispatch(set_auth_token(keycloak.token || ''));
};

const renderApp = () => {
  root.render(
    <Provider store={store}>
      <BrowserRouter basename={config.basename}>
        <App />
      </BrowserRouter>
    </Provider>
  );
};

keycloak.onAuthSuccess = publishSession;
keycloak.onAuthRefreshSuccess = publishSession;
keycloak.onAuthLogout = () => {
  store.dispatch(set_logged_in(false));
  store.dispatch(set_auth_token(''));
};

keycloak
  .init({
    pkceMethod: 'S256',
    onLoad: 'check-sso',
    silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`
  })
  .then(() => {
    publishSession();
    renderApp();
  })
  .catch((err) => {
    console.error(err);
    container.textContent = 'Sign-in is unavailable. Keycloak did not respond.';
  });

serviceWorker.unregister();
